<template>
  <div id="product-apply">
    <head>
      <meta name="description" content="Product apply page">
    </head>
    <b-modal
      id="productapply-modal"
      scrollable
      ref="my-modal"
      hide-footer
      hide-header
      size="lg"
      @show="getInsuranceProp"
      @hidden="resetForm"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-lg"
        role="document"
        style="margin: 0px !important"
      >
        <div class="modal-content">
          <div class="modal-header mb-4">
            <div class="container-fluid mx-0 px-0">
              <div class="row mt-1">
                <div class="col-md-2"></div>
                <div class="col-md-8">
                  <h3 class="text-center px-0">{{ productData.name }}</h3>
                </div>
                <div class="col-md-2"></div>
              </div>
              <div class="row mt-1 py-2 px-2">
                <div class="col-md-6 px-5 col-sm-12">
                  <img :src="getImgUrl()" class="img-fluid" alt />
                </div>
                <div class="col-md-6 col-sm-12">
                  {{ productData.details_stub }}
                  <!-- <router-link :to="`/breast_pumps/pump_details/${productData.slug}`" v-if="!detailed">more info
                  </router-link> -->
                  <router-link
                    :to="`/breast_pumps/pump_details/${productData.slug}`"
                    >more info
                  </router-link>
                  <!-- <a href="#" v-if="detailed" @click="resetForm">more info</a> -->
                </div>
              </div>
            </div>

            <button
              type="button"
              class="close"
              @click="closeApply"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="d-flex justify-content-center">
              <img
                src="@/assets/site/images/loader.gif"
                v-if="loader === true"
                class="img-fluid"
                style="width: 15%"
                alt
              />
            </div>
            <div class="container" v-if="loader === false && success == false">
              <div class="row py-2 px-2">
                <div class="col-md-6">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      :class="{ 'is-invalid': errors.first_name }"
                      v-model="first_name"
                      placeholder="First Name*"
                    />
                    <span class="text-danger" v-if="errors.first_name">{{
                      this.errors.first_name[0]
                    }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input
                      type="text"
                      v-model="last_name"
                      :class="{ 'is-invalid': errors.last_name }"
                      class="form-control"
                      placeholder="Last Name*"
                    />
                    <span class="text-danger" v-if="errors.last_name">{{
                      this.errors.last_name[0]
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="row py-2 px-2">
                <div class="col-md-6">
                  <div class="form-group">
                    <input
                      type="email"
                      v-model="email"
                      :class="{ 'is-invalid': errors.email }"
                      class="form-control"
                      aria-describedby="emailHelp"
                      placeholder="Email Address*"
                    />
                    <span class="text-danger" v-if="errors.email">{{
                      this.errors.email[0]
                    }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input
                      type="text"
                      v-model="phone"
                      :class="{ 'is-invalid': errors.phone }"
                      class="form-control"
                      placeholder="Phone Number*"
                    />
                    <span class="text-danger" v-if="errors.phone">{{
                      this.errors.phone[0]
                    }}</span>
                  </div>
                </div>
              </div>

              <div class="row py-2 px-2">
                <div class="col-md-6">
                  <div class="form-group">
                    <input
                      type="text"
                      v-model="address"
                      :class="{ 'is-invalid': errors.address }"
                      class="form-control"
                      placeholder="Address*"
                    />
                    <span class="text-danger" v-if="errors.address">{{
                      this.errors.address[0]
                    }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input
                      type="text"
                      v-model="city"
                      :class="{ 'is-invalid': errors.city }"
                      class="form-control"
                      placeholder="City*"
                    />

                    <span class="text-danger" v-if="errors.city">{{
                      this.errors.city[0]
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="row py-2 px-2">
                <div class="col-md-6">
                  <div class="form-group">
                    <datepicker
                      v-model="delivery_date"
                      @selected="deliveryDate"
                      placeholder="EDD (Expected Delivery Date)*, M/D/Y"
                      input-class="form-control"
                      style="border: 2px solid #045C68 !important;"
                      :class="{ 'is-invalid': errors.delivery_date }"
                      format="MM/dd/yyyy"
                      :typeable="true"
                    ></datepicker>
                    <!-- <input type="date" v-model="delivery_date" :class="{'is-invalid': errors.delivery_date}"   class="form-control"
                       placeholder="EDD (Expected Delivery Date)*" /> -->
                    <span class="text-danger" v-if="del_date_error!=null">{{
                      this.del_date_error
                    }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input
                      type="text"
                      v-model="doctor"
                      :class="{ 'is-invalid': errors.doctor }"
                      class="form-control"
                      placeholder="OBGYN Doctor*"
                    />
                    <span class="text-danger" v-if="errors.doctor">{{
                      this.errors.doctor[0]
                    }}</span>
                  </div>
                </div>
              </div>

              <div class="row py-1 px-2">
                <div class="col-md-12">
                  <label class="wrap">
                    <select
                      class="form-control noBorder"
                      v-model="insurance_id" @change="getInsurance(insurance_id)"
                    >
                      <option value="">-Select Insurance-</option>
                      <option v-for="carrier in carriers" :value="carrier">
                        {{ carrier.name }}
                      </option>
                      <!-- <option value="Other">Other</option> -->
                    </select>
                  </label>
                  <span class="text-danger" v-if="errors.insurance_id">{{
                    this.errors.insurance_id[0]
                  }}</span>
                </div>
              </div>
              <div
                class="row py-2 px-2"
                v-if="insurance_id !='' && insurance_id.name != 'Others'"
              >
                <div class="col-md-6" >
                  <div class="form-group">
                    <input 
                      type="text" v-if="insurance_status=='Policy Number'"
                      class="form-control"
                      :class="{ 'is-invalid': errors.policy_number }"
                      v-model="policy_number"
                      placeholder="Insurance ID/Policy number*"
                    />
                    <span class="text-danger" v-if="errors.policy_number">{{
                      this.errors.policy_number[0]
                    }}</span>
                     <input 
                     id="dbn"
                      type="text" v-if="insurance_status=='DBN Number'"
                      class="form-control"
                      :class="{ 'is-invalid': errors.dbn_number }"
                      v-model="dbn_number"
                      placeholder="DBN Number*"
                    />
                    <span for="dbn" v-if="insurance_status=='DBN Number'" style="font-size: 13px !important;">*Located on the back of your Tricare Identification Card</span>
                    <span class="text-danger" v-if="errors.dbn_number">{{
                      this.errors.dbn_number[0]
                    }}</span>
                  </div>
                </div>
              
                <div class="col-md-6">
                  <div class="form-group" @click="resetdob">
                    <datepicker
                      v-model="date_of_birth"
                      @selected="birthDate"
                      placeholder="Date of birth*, M/D/Y"
                      input-class="form-control"
                      style="border: 2px solid #045C68 !important;"
                      :class="{ 'is-invalid': errors.date_of_birth }"
                      format="MM/dd/yyyy"
                      :typeable="true"
                    ></datepicker>
                    <!-- <input type="text" @change="dobChange" class="form-control" placeholder="Date of birth*"
                      onfocus="(this.type='date')" v-model="date_of_birth"> -->
                    <span class="text-danger" v-if="birth_date_error!=null">{{
                      this.birth_date_error
                    }}</span>
                  </div>
                </div>
                 <div class="col-md-12 mt-2">
              <div class="form-row">
                <div class="col-md-12 mb-2">
                  <input v-if="upload_status==1"
                    type="file" placeholder="Upload File"
                    v-on:change="onImageChange"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
              </div>
            </div>
          </div>
          <div class="pl-4 mb-4" v-if="loader === false && success == false">
            <div class="row py-2 px-2">
              <div class="col-md-12 text-center" v-if="insurance_id.name == 'Others'">
                <p class="text-primary">
                  <strong
                    >Please call 808-691-9973 to discuss breast pump options
                  </strong>
                </p>
                <p class="text-primary">
                  <strong> for your other health insurance </strong>
                </p>
              </div>
            </div>
            <div class="row mt-1 mb-3">
              <div class="col-md-12 text-center">
                <button
                  type="button"
                  @click="applyProduct"
                  class="btn btn-light px-5"
                >
                  Submit
                </button>
              </div>
            </div>
            <div class="row py-2 px-2">
              <div class="col-md-12 text-center">
                <p class>
                  A representative will reach out to you within 72 hours
                </p>
              </div>
            </div>
          </div>
          <div class="row pt-2 px-2" v-if="success">
            <div class="col-md-12 text-center">
              <img
                src="@/assets/site/images/icons/icon-20.svg"
                style="width: 18% !important"
                class="img-fluid"
                alt
              />
              <h2 class="display-4 text-center my-4">Thank You</h2>
              <p class>
                A representative will reach out to you within 72 hours
              </p>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import Vue from "vue";
Vue.use(require("vue-moment"));
import moment from "moment";

Vue.prototype.moment = moment;
export default {
  name: "ProductApply",
  props: ["productData", "detailed", "success","carriers_list","carrier_id"],
  components: {
    Datepicker,
  },
  data() {
    return {
      first_name: null,
      last_name: null,
      email: null,
      phone: null,
      insurance_id:null,
      errors: [],
      loader: false,
      carriers: [],
      date_of_birth: "1990-01-01",
      // date_of_birth: null,
      dob_change: false,
      policy_number: null,
      address: null,
      city: null,
      delivery_date: null,
      doctor: null,
      del_date_error:null,
      birth_date_error:null,
      dbn_number:null,
      image: null,
      insurance_status:''
     
    };
  },
  created() {
   
    this.getCarriers();
    this.getInsuranceProp();
    this.resetForm();
    // this.resetdob();
  },
  methods: {
   getInsurance(insurance_id){
    this.insurance_status=insurance_id.insurance_status;
    this.upload_status=insurance_id.upload_status;
    // console.log( this.insurance_status);
   },
   getInsuranceProp(){
     if(this.carrier_id == '' | this.carriers_list == ''){
       this.getCarriers();
     }
     this.carriers = this.carriers_list;
    this.insurance_id = this.carrier_id;
    this.getInsurance(this.insurance_id);
    // console.log( this.insurance_status);
   },

    
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    getImgUrl() {
      return this.productData.image;
    },
    applyProduct() {
      //Save or update User Details
      this.errors = [];
      this.loader = true;
      let apiUrl = process.env.VUE_APP_URL + "api/saveApplyProduct";
      let method_type = "post";
      this.deliveryDate(this.delivery_date);
      this.birthDate(this.date_of_birth);
      // if (this.dob_change == false) {
      //     this.date_of_birth = '';
      // }
      fetch(apiUrl, {
        method: method_type,
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          Authorization:
            "Bearer " + $('meta[name="api_token"]').attr("content"),
        },
        body: JSON.stringify({
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          phone: this.phone,
          insurance_id: this.insurance_id.id,
          product_id: this.productData.id,
          date_of_birth: this.date_of_birth,
          policy_number: this.policy_number,
          address: this.address,
          city: this.city,
          delivery_date: this.delivery_date,
          doctor: this.doctor,
          dbn_number:this.dbn_number,
          image:this.image,
          insurance_status:this.insurance_status,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === true) {
            this.resetForm();
            // this.$swal("Success", data.message, "success");
            this.success = true;
            // this.date_of_birth = null;
            // this.dob_change = false;
            this.policy_number = null;
          } else if (data.status === false) {
            this.$swal("Error", data.message, "error");
          } else {
            this.errors = data.errors;
          }
          this.loader = false;
        })
        .catch(function (err) {
          console.log("Conatct Data", "Error : " + err.message, "error");
        });
    },
    resetForm() {
      this.first_name = null;
      this.last_name = null;
      this.email = null;
      this.phone = null;
      this.insurance_id = "";
      this.policy_number = null;
      this.errors = [];
      this.address = null;
      this.city = null;
      this.delivery_date = null;
      this.date_of_birth = null;
      this.doctor = null;
      this.dbn_number=null;
      // this.$bvModal.hide('productapply-modal')
    },
    getCarriers() {
      var method_type = "GET";
      var fetch_url = process.env.VUE_APP_URL + "api/getBrestPumbCarriers";
      fetch(fetch_url, {
        method: method_type,
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data != null) {
            this.carriers = data.carriers;
        
          }
        });
    },
     onImageChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      console.log(file);
      let reader = new FileReader();
      let vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;
        vm.preview_image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    dobChange() {
      this.dob_change = true;
    },
    closeApply() {
      this.resetForm();
      this.success = false;
      this.$bvModal.hide("productapply-modal");
    },
    deliveryDate(date) {
      
      var edd = moment(date).format("yyyy-MM-DD");
      var split_array=edd.split('-');
      this.del_date_error=null;
      if(split_array[0]=='Invalid date'){
        this.del_date_error='Please select date in MM/DD/YYYY format'
      }
      this.delivery_date = edd;

    },
    birthDate(date) {
      var edd = moment(date).format("yyyy-MM-DD");
      this.birth_date_error=null;
      var split_array=edd.split('-');
      if(split_array[0]=='Invalid date'){
        this.birth_date_error='Please select date in MM/DD/YYYY format'
      }
      this.date_of_birth = edd;
    },
    resetdob() {
      if (this.date_of_birth == null) {
        var d = new Date();
        var year = d.getFullYear();
        var month = d.getMonth();
        var day = d.getDate();
        // var date1 = today.getDate()+'-'+(today.getMonth()+1)+'-'+(today.getFullYear()-18);
        var date = new Date(year - 20, month, day).toISOString().substr(0, 10);
        this.date_of_birth = date;
        console.log(date);
      }
    },
  },
};
</script>